import { useIndicatorStore } from "@/data/Stores";
import { ContentType, MethodTypeEnum } from "@/enums";
import {
  IBoundary,
  ICategories,
  INotSure,
  ISelect,
} from "@/types";
import { ApiUrl } from "@/utils/ApiNames";
import { AppRequest } from "@/utils/AppRequest";
import { _baseTimeOut } from "@/utils/AxiosInstance";
import { PHC } from "@/utils/Constant";
import { restructureData } from "@/utils/Misc";

const queryByIndicator = async (
  id: string,
  payload: string,
  signal?: AbortSignal
): Promise<IBoundary> =>
  await AppRequest(
    `${ApiUrl.Indicators}${id}/${payload}`,
    MethodTypeEnum.GET,
    null,
    true,
    _baseTimeOut,
    ContentType.JSON,
    signal
  );

const getCategories = async (id: string): Promise<{ data: ICategories[] }> => {
  const { setCategoryList } = useIndicatorStore.getState();
  const response = await AppRequest(
    `${ApiUrl.IndicatorCategories}?indicator=${id}`
  );
  // const _data = restructureData(response?.data ?? []);
  // setCategoryList(_data);
  const filteredCategories = response?.data?.filter(
    (category: { name: string }) => category.name !== "Facility Type"
  );
  setCategoryList(filteredCategories);
  return response;
};

const downloadData = async (id: string, query: string): Promise<INotSure> => {
  const _url = ApiUrl.IndicatorDownload + id;
  try {
    const response = await AppRequest(
      `${_url}/?${query}`,
      MethodTypeEnum.GET,
      null,
      true,
      200_000
    );
    return response;
  } catch (error) {
    console.error(`Failed to download data`, error);
    throw error;
  }
};

const getIndicators = async (): Promise<ISelect[]> => {
  const { setIndicatorList, setIndicatorType } = useIndicatorStore.getState();
  
  const response = await AppRequest(ApiUrl.Indicators);
  const _data = restructureData(response?.data ?? []);

  const $newIndicatorResp = _data?.map((indicator: ISelect) => ({
    ...indicator,
    label: indicator.label,
    disabled: indicator.value === PHC,
  }));

  setIndicatorList($newIndicatorResp ?? []);
  setIndicatorType([PHC]);
  return _data;
};

const IndicatorApi = {
  queryByIndicator,
  downloadData,
  getCategories,
  getIndicators,
};

export default IndicatorApi;
